/**
 * Copyright Mántum All Rights Reserved.
 */
import { Chart } from './library';
import { Suspense } from 'react';

import type { DataSource, Limit, Series, Theme } from '@mantum/kanela';

type PropTypes = {
    advanced?: {
        allowCrosshair?: boolean;
        allowExporting?: boolean;
        allowLegend?: boolean;
        allowTooltip?: boolean;
        entity?: string;
        refresh?: number;
        revalidate?: boolean;
        type?: 'bar' | 'area' | 'line' | 'spline' | 'simple' | 'playful';
    };
    dataSource?: DataSource | unknown[];
    icon?: string;
    limit?: Limit;
    name?: string;
    series?: Series;
    subtitle?: string;
    theme?: Theme;
    title?: string;
};

const KEY_SIMPLE = 'simple';
const KEY_PLAYFUL = 'playful';

export default function Index(props: PropTypes) {
    // prettier-ignore
    const {
        advanced = {},
        dataSource = []
    } = props

    // prettier-ignore
    const {
        type = 'bar'
    } = advanced

    const internal =
        type === KEY_SIMPLE || type === KEY_PLAYFUL ? 'card' : type;

    const build =
        type === KEY_SIMPLE || type === KEY_PLAYFUL ? type : undefined;

    return (
        <Suspense>
            <Chart
                advanced={{ ...advanced, type: build }}
                dataSource={dataSource}
                icon={props.icon}
                limit={props.limit}
                series={props.series}
                subtitle={props.subtitle}
                theme={props.theme}
                title={props.title}
                type={internal}
            />
        </Suspense>
    );
}
